export { TruncateModule, TRUNCATE_PIPES } from './truncate.module';

export {TruncateCharactersPipe} from './truncate-characters.pipe';
export {TruncateWordsPipe} from './truncate-words.pipe';
//# sourceMappingURL=index.js.map